import { Switch } from "../../../../../components/ui";

export interface SmartSwitchProps {
  checked: boolean;
  onChange: () => void;
  disabled?: boolean;
  label: string;
}

export default function SmartSwitch({
  checked,
  onChange,
  disabled = false,
  label,
}: SmartSwitchProps) {
  return (
    <Switch
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      aria-label={label}
    />
  );
}
